import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '@/views/HomeView.vue';

const routes = [
    { path: '/connect', name: 'connect', component: () => import('@/views/ConnectView.vue'), meta: { title: 'Connect with West Dev Solutions', description: 'Chat with Adrian on WhatsApp, follow West Dev Solutions on Instagram, or save our contact details. Websites, apps and automation for your business.' } },
    {
        path: '/',
        name: 'home',
        component: HomeView,
        meta: {
            title: 'West Dev Solutions · Backend, Apps & Automation',
            description: 'West Dev Solutions builds backend systems, web and mobile apps, API integrations and workflow automation for growing businesses. Work directly with engineer Adrian West.'
        }
    },
    { path: '/:pathMatch(.*)*', redirect: '/' }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to) {
        if (to.hash) {
            return { el: to.hash, behavior: 'smooth' };
        }
        return { top: 0 };
    }
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || 'West Dev Solutions';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
        metaDescription.setAttribute('content', to.meta.description || '');
    }
    const url = `https://westdevsolutions.com${to.path}`;
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', url);
    for (const [selector, content] of [
        ['meta[property="og:url"]', url],
        ['meta[property="og:title"]', document.title],
        ['meta[name="twitter:title"]', document.title],
        ['meta[property="og:description"]', to.meta.description || ''],
        ['meta[name="twitter:description"]', to.meta.description || ''],
    ]) document.querySelector(selector)?.setAttribute('content', content);
    next();
});

export default router;
